import React from "react";
import { useTheme } from "../context/ThemeContext";

const StrategyMenu = ({ data }) => {
  const { theme } = useTheme();
  const maxProfit = data?.["maxProfit"] ?? "--";
  const maxLoss = data?.["maxLoss"] ?? "--";
  const riskReward = data?.["riskReward"] ?? "--";
  const breakevenRange = data?.["breakevenRange"] ?? "--";
  const strategyDirection = data?.["strategyDirection"] ?? "--";

  function formatNumberWithCommasAndFontWeight(value) {
    let parts = String(value).match(/^(\$)(\d+)(\.\d+)?/);
    if (!parts) {
      return value;
    }
    return (
      <span>
        {parts[0]}.<span style={{ fontWeight: 400 }}>{parts[1]}</span>
      </span>
    );
  }

  const Divider = () => <div className="strategy-divider" />;

  return (
    <div className="bg-p400 flex flex-wrap items-center px-3 py-[19.5px] rounded-md shadow-sm justify-between gap-x-2 w-full">
      <div className=" flex flex-col">
        <span className="creator-bottom-title">Type</span>
        <span className="creator-bottom-value">{strategyDirection}</span>
      </div>
      <Divider />
      <div className=" flex flex-col ">
        <span className="creator-bottom-title">Max profit</span>
        <span className="creator-bottom-value max-profit">
          {formatNumberWithCommasAndFontWeight(maxProfit)}
        </span>
      </div>
      <Divider />
      <div className=" flex flex-col ">
        <span className="creator-bottom-title">Max loss</span>
        <span className="creator-bottom-value max-loss">
          {formatNumberWithCommasAndFontWeight(maxLoss)}
        </span>
      </div>
      <Divider />
      <div className=" flex flex-col">
        <span className="creator-bottom-title">Risk:Reward</span>
        <span className="creator-bottom-value">{riskReward}</span>
      </div>
      <Divider />
      <div className=" flex flex-col">
        <span className="creator-bottom-title">Breakeven range</span>
        <span className="creator-bottom-value">
          {formatNumberWithCommasAndFontWeight(breakevenRange)}
        </span>
      </div>
    </div>

  );
};

export default StrategyMenu;
